import Button from "../../../components/base/Button";
import HeroBack from "../../../assests/images/HeroBackground.jpg";
export default function HeroSection() {
  const scrollToLocation = () => {
    const locationSection = document.getElementById("location");
    if (locationSection) {
      locationSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${HeroBack})`,
        }}
      ></div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          Brewing as an Artform
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto leading-relaxed">
          Experience Delhi's finest specialty coffee and premium matcha at
          Majnu-ka-tilla
        </p>

        <div className="flex justify-center items-center">
          <Button
            variant="outline"
            size="lg"
            onClick={scrollToLocation}
            className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-black min-w-[160px]"
          >
            Visit Us
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
